
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Confirm',
  props: {
    title: String,
    desc: String
  },
  setup(props, { emit }) {
    function cancel() {
      emit('cancel', true)
    }
    function confirm() {
      emit('confirm', true)
    }
    return { cancel, confirm }
  }
})
